/* eslint-disable global-require, import/no-dynamic-require */
import React, { useState } from 'react';
import createContainer from 'constate';
import { nameHOC } from './hocutils';

function useLabelsHook({ labels: translations }) {
  const [labels] = useState(translations);
  return { labels };
}

const [LabelProvider, useLabel] = createContainer(useLabelsHook);

const withLabels = (WrappedComponent) => {
  const { getInitialProps } = WrappedComponent;
  const ComponentWithLabels = (props) => {
    const { labels } = useLabel();
    return <WrappedComponent {...props} labels={labels} />;
  };
  if (typeof getInitialProps === 'function') {
    ComponentWithLabels.getInitialProps = getInitialProps;
  }
  ComponentWithLabels.originalName = nameHOC(WrappedComponent);
  ComponentWithLabels.displayName = nameHOC(WrappedComponent, 'WithLabels');
  return ComponentWithLabels;
};

export { withLabels, LabelProvider };
